"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationEventParameterMapping = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const notification_parameter_entity_1 = require("./notification_parameter.entity");
const notification_event_type_entity_1 = require("./notification-event-type.entity");
let NotificationEventParameterMapping = class NotificationEventParameterMapping {
};
exports.NotificationEventParameterMapping = NotificationEventParameterMapping;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)({ name: "id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], NotificationEventParameterMapping.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "event_type_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], NotificationEventParameterMapping.prototype, "eventTypeId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "parameter_definition_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], NotificationEventParameterMapping.prototype, "parameterDefinitionId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ default: false }),
    tslib_1.__metadata("design:type", Boolean)
], NotificationEventParameterMapping.prototype, "required", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => notification_event_type_entity_1.NotificationEventType),
    (0, typeorm_1.JoinColumn)({ name: 'event_type_id' }),
    tslib_1.__metadata("design:type", typeof (_a = typeof notification_event_type_entity_1.NotificationEventType !== "undefined" && notification_event_type_entity_1.NotificationEventType) === "function" ? _a : Object)
], NotificationEventParameterMapping.prototype, "eventType", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => notification_parameter_entity_1.NotificationParameter),
    (0, typeorm_1.JoinColumn)({ name: 'parameter_definition_id' }),
    tslib_1.__metadata("design:type", typeof (_b = typeof notification_parameter_entity_1.NotificationParameter !== "undefined" && notification_parameter_entity_1.NotificationParameter) === "function" ? _b : Object)
], NotificationEventParameterMapping.prototype, "parameterDefinition", void 0);
exports.NotificationEventParameterMapping = NotificationEventParameterMapping = tslib_1.__decorate([
    (0, typeorm_1.Entity)('notification_event_parameter_mapping')
], NotificationEventParameterMapping);
